module.exports = __webpack_public_path__ + "fce22ca610cc9727cc320241ee61e140.png";